import {VariantConfigT} from '@/lib/types/colors.types';

export const tealConfig: VariantConfigT = {
  basic: {
    icon: 'teal',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'teal',
    active: 'teal',
  },
  outline: {
    icon: 'teal',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  ghost: {
    icon: 'teal',
    iconHover: 'teal',
    iconActive: 'teal',
    hover: 'teal',
    active: 'teal',
  },
  gradient: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
  solid: {
    icon: 'white',
    iconHover: 'white',
    iconActive: 'white',
    hover: 'white',
    active: 'white',
  },
};
